import React, { Component } from 'react';
import PropTypes from 'prop-types';

import FiltersBar from '../../common/filters-bar/filters-bar';

class TagsFiltersBar extends Component {
  render() {
    return (
      <FiltersBar 
        items={this.props.tags} 
        onFilterClick={this.props.onFilterClick}
        isAllOn={this.props.isAllOn}
        onClearAllClick={this.props.onClearAllClick} />
    );
  }
}

TagsFiltersBar.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    text: PropTypes.string
  })).isRequired,
  onFilterClick: PropTypes.func.isRequired,
  isAllOn: PropTypes.bool,
  onClearAllClick: PropTypes.func
};

TagsFiltersBar.defaultValues = {
  isAllOn: true
};

export default TagsFiltersBar;